
<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable 
      max-width="1000px"
      transition="dialog-transition"
      style="border-radius: 40px;"
    >
      <base-card>
        <template slot="title">
          <span class="text-capitalize pa-3 font-weight-bold">
            {{ $tc('companies.users')}}
          </span>
        </template>
        <template slot="btn-slot">
          <v-btn
            color="primary"
            rounded
            small
            class="white--text elevation-0 text-capitalize"
            @click="getCompanyUsers()"
          >
            <v-icon left small>mdi-reload</v-icon>
            Atualziar
          </v-btn>
        </template>

        <template v-slot:content>
          <v-form ref="companyForm" :disabled="!is_editing" v-if="!loading" class="px-3">
            <!-- <company-form :one_company="one_company"></company-form> -->
            <company-users-list :users="company_users"></company-users-list>
          </v-form>
        </template>


        <template slot="actions" v-if="false">
          <template v-if="is_editing">
            <v-btn small color="error" class="font-weight-bold" @click="cancelCompany" text>{{ $t('cancel') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn small color="primary" class="font-weight-bold" @click="saveCompany" text>{{ $t('save') }}</v-btn>
          </template>
          <template v-if="!is_editing">
            <v-spacer></v-spacer>
            <v-btn small color="primary" class="font-weight-bold" @click="is_editing = true" text>{{ $t('edit') }}</v-btn>
          </template>
        </template>

      </base-card>
    </v-dialog>

    <dialog-loading v-if="saving" loadingText="saving" ></dialog-loading>
    <dialog-loading v-if="loading" loadingText="loading" ></dialog-loading>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from '@/mixins/validations'
import Api from '@/api/index';
import AddressForm from '../../shared/forms/AddressForm.vue';
import CompanyForm from './shared/CompanyForm.vue';
import CompanyUsersList from './shared/CompanyUsersList.vue';

export default {
  name: 'DialogEditCompanyUsers',
  mixins: [ validations ],
  components: {
    AddressForm,
    CompanyForm,
    CompanyUsersList
    //ComponentName: () => import(''),
  },
  data() {
    return {
      dialog: true,

      is_editing: false,

      loading: false,
      saving: false,

      company_users: [],
      
    }
  },
  methods: {
    cancelCompany(){
      this.is_editing=false
    },
    getCompanyUsers(){
      this.loading = true
      Api.User.index({company_id: this.$route.params.id}).then(r=> r.data).then(d=> {
        console.log({d});
        this.company_users = [...d]
        // const {json_attributes, ...company} = d
        // this.one_company = {
        //   ...company,
        //   ...json_attributes
        // }
      }).catch(err=> {
        console.log({err});
      }).finally(()=>{
        setTimeout(() => {
          this.loading = false
        }, 1200);
      })
    },
    saveCompany(){
      if (this.$refs.companyForm.validate()){
        this.saving = true
        Api.Company.update(this.one_company).then(r=> {
          this.$router.go(-1)
        }).catch(err=> {
          console.log({err});
        }).finally(()=>{
          this.saving = false
        })
      }
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  mounted () {
    this.getCompanyUsers();
  },
  watch: {
    dialog(nv,ov) {
      if (nv){
  
      } else if (nv == false){
        this.$router.go(-1)
      }
    }
  },
}
</script>

<style scoped>

</style>